import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as gamesMainActions from './modules/games-main-actions';
import {bindActionCreators} from 'redux';
import DataTable from '../../../../../../components/data-table/data-table';
import Button from '../../../../../../components/button';
import DateDisplay from '../../../../../../components/date-display';
import DocumentTitle from '../../../../../../components/document-title';
import Icon from '../../../../../../components/icon';

class GamesContainer extends Component {

    state = {
        search: {
            query: '',
            order_field: 'date',
            order: 'desc'
        }
    };

    fetchItems(page, params) {
        if (!params) {
            params = this.state.search;
        }
        this.props.actions.getGames({
            page,
            ...params
        });
    }

    loadItems = (paginationInfo) => {
        this.fetchItems(paginationInfo.page);
    };


    componentWillMount() {
        this.fetchItems(0);
    }

    renderTable() {
        const config = {
            cols: [
                {
                    value: (item) => {
                        return (<div>{item.home_team} - {item.away_team}</div>);
                    },
                    header: 'Komandos',
                },
                {
                    value: (item) => {
                        return <DateDisplay date={item.date} time={true}/>;
                    },
                    header: 'Data',
                },
                {
                    value: 'address',
                    header: 'Adresas',
                },
                {
                    value: 'comment',
                    header: 'Komentaras',
                },
                {
                    value: (item)=>{
                        return item.league.name;
                    },
                    header: 'Lyga',
                },
                {
                    value: (item) => {
                        if (item.approved) {
                            return <Icon icon="ok" className="form-icon"/>;
                        }
                        return <Icon icon="ko" className="form-icon"/>;
                    },
                    header: 'Rungtynės patvirtintos'
                },
                {
                    header: 'Veiksmai', value: (item) => {
                    return <Button to={`/app/games/${item.id}`}>Redaguoti</Button>;
                }
                }
            ],
            initialState: {
                order_field: this.state.search.order_field,
                order: this.state.search.order
            }
        };
        const {items, loading, currentPage, totalPages} = this.props.games;
        return <DataTable config={config} items={items} loadAction={this.loadItems}
                          currentPage={currentPage} totalPages={totalPages}
                          loading={loading} className="games-table mt-10"/>;
    }

    render() {
        return (<DocumentTitle title="Rungtynės">
            <div><Button to="/app/games/new">Pridėti rungtynes</Button>{this.renderTable()}</div>
        </DocumentTitle>);
    }
}


export default connect(function (state) {
    return {games: state.app.games.main.games};
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...gamesMainActions
        }, dispatch)
    };
})(GamesContainer);



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/main/games-main-container.jsx